"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isTablet = exports.isMobile = exports.isDesktop = exports.DEVICE_TYPE = void 0;
var DEVICE_TYPE = /*#__PURE__*/function (DEVICE_TYPE) {
  DEVICE_TYPE["bot"] = "bot";
  DEVICE_TYPE["car"] = "car";
  DEVICE_TYPE["desktop"] = "desktop";
  DEVICE_TYPE["phone"] = "phone";
  DEVICE_TYPE["tablet"] = "tablet";
  DEVICE_TYPE["tv"] = "tv";
  return DEVICE_TYPE;
}(DEVICE_TYPE || {});
exports.DEVICE_TYPE = DEVICE_TYPE;
var isDesktop = function isDesktop(deviceType) {
  return [DEVICE_TYPE.desktop, DEVICE_TYPE.tv].includes(deviceType);
};
exports.isDesktop = isDesktop;
var isMobile = function isMobile(deviceType) {
  return [DEVICE_TYPE.phone, DEVICE_TYPE.tablet, DEVICE_TYPE.car, DEVICE_TYPE.bot].includes(deviceType);
};
exports.isMobile = isMobile;
var isTablet = function isTablet(deviceType) {
  return deviceType === DEVICE_TYPE.tablet;
};
exports.isTablet = isTablet;